import React from 'react';
import { formatDate } from '../../lib/utils';

// Shows the current ETA; when revised, adds a tag and strikes through the original date.
export function EtaDisplay({ booking, prefix = '', className = '', testId = 'eta-display' }) {
  const eta = booking.estimated_delivery || booking.estimated_arrival;
  const revised = Boolean(booking.eta_revised_at) && booking.original_eta && booking.original_eta.slice(0, 10) !== String(eta).slice(0, 10);
  return (
    <span className={"inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 " + className} data-testid={testId} title={revised ? 'Revised: ' + (booking.eta_revision_reason || '') : undefined}>
      <span className="sv-mono whitespace-nowrap" data-testid={testId + '-date'}>{prefix}{formatDate(eta)}</span>
      {revised && (
        <>
          <span className="sv-mono text-gray-500 line-through whitespace-nowrap" data-testid={testId + '-original'}>{formatDate(booking.original_eta)}</span>
          <span className="inline-flex items-center rounded-full bg-amber-100 text-amber-800 text-[11px] font-medium leading-none px-2 py-1 uppercase tracking-[0.04em]" data-testid={testId + '-revised-tag'}>Revised</span>
        </>
      )}
    </span>
  );
}
